"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cookieSupportChecks = require("./cookieSupportChecks");
var cookieDomain = process.env.REACT_APP_GOOGLE_OAUTH_COOKIE_DOMAIN || process.env.NEXT_PUBLIC_GOOGLE_OAUTH_COOKIE_DOMAIN;
var deleteCookie = function deleteCookie(name) {
  document.cookie = "".concat(name, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=").concat(cookieDomain, ";secure;samesite=").concat((0, _cookieSupportChecks.isSameSiteStrictSupported)() ? 'strict' : 'lax', ";");
};
var _default = exports["default"] = deleteCookie;